import { IRemoteQueryAgent } from '../../settings/types/ISiteSettingsForSiteAdmin';
import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { Module } from '../Module';
import { ServerUsers } from '../resources/ServerUsers';
import { IError } from '../ServerApi/types/IError';
import { IResult } from '../ServerApi/types/IResponse';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { ContentActionNotification } from './ContentActionNotification';
import { ModalService } from './ModalService';

export class DeleteRemoteAgentAction {

  public static $inject = [
    '$translate',
    'ConfirmActionDialog',
    'ContentActionNotification',
    'ServerUsers'
  ];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private ConfirmActionDialog: ConfirmActionDialog,
    private ContentActionNotification: ContentActionNotification,
    private ServerUsers: ServerUsers) { }

    public execute(agent: IRemoteQueryAgent, ownerId: string, context: IActionContext): ng.IPromise<IResult> {
       return this.ConfirmActionDialog.open({
         scope: context.scope.$new(),
         title: this.$translate.instant('deleteMessage'),
         bodyText: this.$translate.instant('confirmDeleteRemoteAgent', {NAME: L10n.elideIfLong(agent.agentName)}),
         position: ModalService.anchoredTo(context.targetElement),
         actionName: this.$translate.instant('deleteMessage'),
         action: (dialogInstance: IConfirmActionDialogInstance) => {
           return this.ServerUsers.deleteUserRemoteAgents(ownerId, [agent.deviceId])
             .then((result: IResult) => {
               if (result.errors && result.errors.length) {
                 const errorMessage = this.errorMessageFor(result.errors[0]);
                 dialogInstance.showErrorMessage(errorMessage);
               } else {
                 this.ContentActionNotification.notifySuccess(
                   this.$translate.instant('deleteConnectedAgentSuccess', {NAME: L10n.elideIfLong(agent.agentName)}));
               }
               return result;
             });
         }
       }).result;
      }

  private errorMessageFor(error: IError) {
    return this.$translate.instant('errorUnknown');
  }

}

Module.instance().service('DeleteRemoteAgentAction', DeleteRemoteAgentAction);
